// we don't do any error checking on props, we assume the caller has done that already
// color (string), width (number of pixels), and height (number of pixels) should always be specified
const Icon = (props) => (
	<>
		<svg
			width={props.width}
			height={props.height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle cx="12.5" cy="10.5" r="4.5" fill={props.color} />
			<path
				d="M17 18C19 16 20.5 14.5 20.5 10.5C20.5 5.5 17.5 3 12.5 3C8.5 3 5 5.99997 5 9.99997C5 13.2 5 18.3333 5 20.5"
				stroke={props.color}
				strokeWidth="2"
			/>
			<path d="M2 17L5 20L8 17" stroke={props.color} strokeWidth="2" />
		</svg>
	</>
);

export default Icon;
